module.exports = __webpack_public_path__ + "static/media/error-icon.87c450ee.svg";